export default __webpack_public_path__ + "static/media/Thumb_Hairstyle_17.f45cd1ca.png";